export enum ArchivedActivityTableColumnTitle {
  Date = "Datum akt.",
  Activity = "Aktivnost",
  Channels = "Kanal",
  FirstName = "Ime",
  LastName = "Prezime",
  Program = "Program",
  State = "Stanje aktivnosti",
}
